import { render, staticRenderFns } from "./ChangePlanConfirmation.vue?vue&type=template&id=18aa6354&scoped=true&"
import script from "./ChangePlanConfirmation.vue?vue&type=script&lang=js&"
export * from "./ChangePlanConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa6354",
  null
  
)

export default component.exports